import React from 'react';
import * as S from './TransactionsItem.styles';
import { Transaction } from '@/mock-data/transactions';
import { AngleBackIcon } from '@/components/UI/Icons/Icons';
import { Button } from '@/components/UI/Button/Button';
import { formatNumber } from '@/utils/helpers';
import { Typography } from '@/components/UI/Typography/Typography.styles';

interface TransactionsItemProps {
  transaction: Transaction;
  showTxDetails: (tx: Transaction) => void;
}

export const TransactionsItem: React.FC<TransactionsItemProps> = ({
  transaction,
  showTxDetails,
}) => {
  return (
    <S.Box onClick={() => showTxDetails(transaction)}>
      <S.Column>
        <Typography.Body $variant="1">{transaction.service}</Typography.Body>
        <S.Number $variant="1">№ {transaction.paymentNumber}</S.Number>
      </S.Column>
      <S.Column>
        <S.Price $variant="1">
          {formatNumber(transaction.amount, 2)} AZN
        </S.Price>
        <S.Date $variant="1">{transaction.date}</S.Date>
      </S.Column>
      <Button hasPadding={false} appearance="transparent">
        <AngleBackIcon isRotated />
      </Button>
    </S.Box>
  );
};
